export default __webpack_public_path__ + "static/media/popular.9b9c8eb3.svg";